// Recovered compiled webpack factory 54402. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { L: () => i });
  var n = r(49636),
    a = r(21010);
  let o = null;
  function i(e) {
    let t = "error";
    ((0, a.s5)(t, e), (0, a.AS)(t, s));
  }
  function s() {
    ((o = n.O.onerror),
      (n.O.onerror = function (e, t, r, n, i) {
        return (
          (0, a.aj)("error", { column: n, error: i, line: r, msg: e, url: t }),
          !!o && o.apply(this, arguments)
        );
      }),
      (n.O.onerror.__SENTRY_INSTRUMENTED__ = !0));
  }
}
